// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'//引入vue-router
import App from './App.vue'
import routerIndex from './router/index.js' //路由的配置
import axios from 'axios'
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import VideoPlayer from 'vue-video-player'
Vue.use(VideoPlayer);
Vue.config.productionTip=false;
Vue.config.devtools = false;

Vue.use(VueRouter);//使用vue-router
const router = new VueRouter(routerIndex);//创建路由实例

Vue.use(iView);
Vue.prototype.$http=axios;//将axios应用到所有组件

new Vue({
  el: '#app',
  render: h => h(App),
  router
})




// WEBPACK FOOTER //
// ./src/main.js